import { animate, scroll } from 'motion';

const Ingredients = () => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('ingredients', (blockCount) => ({
      blockCount,
      height: 0,
      activeBlock: 0,
      activeImage: null,
      activeMobileImage: null,
      ingredientsListOpen: false,
      calculate() {
        this.height = parseInt(this.blockCount + 1) * 100;
        this.$refs.container.style.height = `calc(${this.height}vh - var(--header-height))`;
      },
      init() {
        this.calculate();

        this.activeImage = this.$refs[`block-${this.activeBlock}`].dataset.image;
        this.activeMobileImage = this.$refs[`block-${this.activeBlock}`].dataset.mobileImage;

        const blockAsPercent = 100 / this.blockCount;

        scroll(
          (info) => {
            const activePercent = this.activeBlock * blockAsPercent;

            if (info.y.progress * 100 > activePercent + blockAsPercent) {
              this.activeBlock++;
            } else if (info.y.progress * 100 < activePercent) {
              this.activeBlock--;
            }

            this.activeImage = this.$refs[`block-${this.activeBlock}`].dataset.image;
            this.activeMobileImage = this.$refs[`block-${this.activeBlock}`].dataset.mobileImage;
          },
          {
            target: this.$refs.container,
          }
        );

        for (let i = 0; i < this.blockCount; i++) {
          const heightOffset = i * 100;
          const offsets = [
            `${heightOffset}vh`,
            `${heightOffset + 25}vh`,
            `${heightOffset + 75}vh`,
            `${heightOffset + 100}vh`,
          ];

          const opacity = [0, 1, 1, 0];

          if (i === 0) {
            opacity[0] = 1;
          }

          scroll(
            animate(this.$refs['block-' + i], {
              opacity,
              y: ['10px', 0, 0, '-10px'],
            }),
            {
              target: this.$refs.container,
              offset: offsets,
            }
          );
        }
      },
      resize() {
        this.calculate();
      },
      openIngredientsList() {
        this.ingredientsListOpen = true;
        this.$dispatch('scroll:lock', { element: this.$root });
        this.$dispatch('overlay:open');
      },
      closeIngredientsList() {
        this.ingredientsListOpen = false;
        this.$dispatch('scroll:unlock', { element: this.$root });
        this.$dispatch('overlay:close');
      },
      toggleIngredientsList() {
        this.ingredientsListOpen = !this.ingredientsListOpen;

        if (this.ingredientsListOpen) {
          this.$dispatch('scroll:lock', { element: this.$root });
          this.$dispatch('overlay:open');
        } else {
          this.$dispatch('scroll:unlock', { element: this.$root });
          this.$dispatch('overlay:close');
        }
      },
    }));
  });
};

export default Ingredients;
